import * as marietta from '../..';

export default class BuildStyleManager {
  items: any = {};

  files: any[] = ['assets/buildStyle/style1.json', 'assets/buildStyle/style2.json', 'assets/buildStyle/style3.json', 'assets/buildStyle/style4.json', 'assets/buildStyle/style5.json', 'assets/buildStyle/style6.json', 'assets/buildStyle/style7.json', 'assets/buildStyle/style8.json'];

  getList() {
    // スタイルを変更
    const self = this;
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}buildStyle/index.xml?${new Date().getTime()}`;

    fetch(url, { method: 'GET' })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        }
        throw Error(response.statusText);
      })
      .then((info) => {
        const datXML = new window.DOMParser().parseFromString(info, 'text/xml');
        self.parseXml(datXML);
        // スタイル選択をコメントアウト
        document
          .getElementById('buildStyleDialog')
          .querySelectorAll('.buildStyleBtn')
          .forEach((elem) => {
            elem.addEventListener('click', (e: any) => {
              self.selectStyleEventHander(e);
            });
          });
      })
      .catch(() => {
        // 何もしない
        console.error(`${url} の取得に失敗しました。`);
      });
  }

  /**
   * xmlデータ取得
   */
  private parseXml(xml: XMLDocument) {
    const self = this;
    let cnt = 0;
    xml.querySelectorAll('item').forEach((item) => {
      self.items[cnt] = {};
      self.items[cnt].id = item.getAttribute('id');
      self.items[cnt].namejp = item.querySelector('namejp').textContent;
      self.items[cnt].nameen = item.querySelector('nameen').textContent;
      self.items[cnt].file = item.querySelector('file').getAttribute('src');
      self.items[cnt].pic = item.querySelector('pic').getAttribute('src');
      self.items[cnt].text = item.querySelector('text').textContent;
      cnt += 1;
    });

    // マネージャーにデータ渡す
    marietta.webcad.WebCADGlobal.webcad2Dmanager.buildStyleListData = this.items;

    // ダイアログ表示
    // スタイル選択をコメントアウト
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.BuildStyleMenu, true);
    // this.setStyle(0);
  }

  /**
   * 建物のスタイルが選択された
   */
  selectStyleEventHander = (e: MouseEvent) => {
    e.preventDefault();
    const index = Array.from((<HTMLElement>e.currentTarget).parentNode.children).indexOf(<HTMLElement>e.currentTarget);
    this.setStyle(index);
  };

  /**
   * 建物のスタイルをセット
   */
  setStyle(index: number, filePath:string = '') {
    // クリックされたビルドスタイルのXMLファイルパス取得
    let path = this.items[0] ? this.items[index].file : this.files[index];
    if (filePath !== '') path = filePath;
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + path}?rand=${String(Math.random())}`;

    fetch(url, { method: 'GET' })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        }
        throw Error(response.statusText);
      })
      .then((info) => {
        let jsonData;
        if (typeof info === 'object') {
          jsonData = info;
        } else {
          jsonData = JSON.parse(info);
        }
        const modelParamNode: any = {};
        modelParamNode.option = jsonData.model_param.option ? jsonData.model_param.option : null;
        modelParamNode.height = jsonData.model_param.height ? jsonData.model_param.height : null;
        modelParamNode.auto = jsonData.model_param.auto ? jsonData.model_param.auto : null;
        modelParamNode.material = jsonData.model_param.material ? jsonData.model_param.material : null;
        marietta.webcad.util.WebcadJSONParser.reproduceModelParam(modelParamNode);

        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
          //Lidarでは、グレード設定をする
          // marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D();
        } else if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
          marietta.webcad.WebCADGlobal.showConfirmDialog(marietta.webcad.collection.WebCADMessages.getText('CONFIRM_STYLE_SETTING'), '', marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D);
        }

        // 変更フラグを立てる
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
      })
      .catch(() => {
        // 何もしない
        console.error(`${url} の取得に失敗しました。`);
      });
  }
}
